module.exports = __webpack_public_path__ + "img/galerie-36.87ebf022.jpg";